var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#864e20}"))), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 7.656,
    style: {
      fill: "#f8de40"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.907 9.844a.182.182 0 0 1-.331.1 2.016 2.016 0 0 0-.569-.567 1.731 1.731 0 0 0-1.915 0 2.016 2.016 0 0 0-.571.569.182.182 0 0 1-.331-.1 1.632 1.632 0 0 1 .346-1.023 1.927 1.927 0 0 1 3.026 0 1.64 1.64 0 0 1 .345 1.021zM18.81 9.844a.182.182 0 0 1-.331.1 2.026 2.026 0 0 0-.568-.567 1.732 1.732 0 0 0-1.916 0 2.016 2.016 0 0 0-.571.569.182.182 0 0 1-.331-.1 1.632 1.632 0 0 1 .346-1.023 1.927 1.927 0 0 1 3.026 0 1.64 1.64 0 0 1 .345 1.021z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23 13.938a14.69 14.69 0 0 1-12.406 6.531c-5.542 0-6.563-1-9.142-2.529A7.66 7.66 0 0 0 8.656 23h6.688A7.656 7.656 0 0 0 23 15.344z",
    style: {
      fill: "#e7c930"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.308 13.375a1.183 1.183 0 0 0 .434-.908 1.34 1.34 0 0 0-.984-1.2.31.31 0 0 0-.414.228v.005a.312.312 0 0 0 .2.355c.215.081.575.269.575.613 0 .425-.5.608-.516.616a.317.317 0 0 0-.21.3.311.311 0 0 0 .226.292.715.715 0 0 1 .5.68c0 .268-.366.453-.584.54a.3.3 0 0 0-.145.119l-.1.024.061.243a.311.311 0 0 0 .412.2c.366-.146.98-.486.98-1.123a1.285 1.285 0 0 0-.435-.984z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIcon);
export default __webpack_public_path__ + "static/media/love-icon.16cd058019774890581dc40479c8a8a3.svg";
export { ForwardRef as ReactComponent };